export const getSiteNatureRiskSiteId = (pathname: string): string | null => {
    const siteIdMatch = pathname.match(/\/site-nature-risk\/([^/]+)/);
    return siteIdMatch ? siteIdMatch[1] : null;
};
